import {
  GET_ALL_WORKFLOWS,
  GET_WORKFLOW,
  LOADING_WORKFLOW,
  ERROR_WORKFLOW,
  ADD_WORKFLOW,
  UPDATE_WORKFLOW,
  DELETE_WORKFLOW
} from "store/actions/workflowAction";

export default (store = {}, action) => {
  switch (action.type) {
    case LOADING_WORKFLOW:
      return {
        ...store,
        isLoadingWorkflow: action.payload
      };
    case ERROR_WORKFLOW:
      return {
        ...store,
        errorWorkflow: action.payload
      };
    case GET_ALL_WORKFLOWS:
      return {
        ...store,
        getAllWorkflows: action.payload
      };
    case GET_WORKFLOW:
      return {
        ...store,
        getWorkflow: action.payload
      };
    case ADD_WORKFLOW:
      return {
        ...store,
        addWorkflow: action.payload
      };
    case UPDATE_WORKFLOW:
      return {
        ...store,
        updateWorkflow: action.payload
      };
    case DELETE_WORKFLOW:
      return {
        ...store,
        deleteWorkflowStatus: action.payload
      };
    default:
      return store;
  }
};
